import { initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";
import { OverigeWerkzaamhedenModalType } from "../infra/inkomen-en-fiscus-schema";
import { determineGemiddeldInkomensVerleden } from "../infra/shared-components/determine-inkomensverleden-side-effects";

export const overigeWerkzaamhedenModalSideEffects = initISWSideEffect<OverigeWerkzaamhedenModalType>(bag => {
  determineGemiddeldInkomensVerleden(bag.subset.inkomensverleden.create());
});
